module.exports = __webpack_public_path__ + "static/media/tr_imageCajaSeca1.88305da8.jpg";